import { useEffect, useState } from 'react';

const preloadImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img: HTMLImageElement = new Image();

    img.onload = () => {
      resolve(img);
    };

    img.onerror = img.onabort = () => {
      reject(src);
    };

    img.src = src;
  });

export const useImagePreloader = (imageList: string[]) => {
  const [imagesPreloaded, setImagesPreloaded] = useState<boolean>(false);

  useEffect(() => {
    let isCancelled = false;

    async function loadImagesAsync() {
      if (isCancelled) {
        return;
      }

      const imagesPromiseList: Promise<HTMLImageElement>[] = [];
      for (const imgUrl of imageList) {
        imagesPromiseList.push(preloadImage(imgUrl));
      }

      await Promise.all(imagesPromiseList);

      if (isCancelled) {
        return;
      }

      setImagesPreloaded(true);
    }

    loadImagesAsync();

    return () => {
      isCancelled = true;
    };
  }, [imageList]);

  return { imagesPreloaded };
};
